import { Component } from 'preact'
import ButtonControl from '../button-control'
import IntegrationHeader from './IntegrationHeader'
import Panel from '../panel'
import InputGroup from '../ui-components/InputGroup'
import ZapierLogo from './assets/zapierLogo.js'
import axios from 'axios'

class ZapierIntegration extends Component {
  constructor ({ csrfToken }) {
    super()
    this.state = {
      apiKey: null
    }
    this.endpoint = '/integration/zapier/settings'
    this.onGenerateApiKey = this.onGenerateApiKey.bind(this)
  }
  componentDidMount () {
    axios.get(this.endpoint)
      .then(res => {
        this.setState({ apiKey: ('key' in res.data) ? res.data.key : null })
      }).catch(() => {
        this.setState({ apiKey: 'Could not retrieve key, please try again later.' })
      })
  }
  onGenerateApiKey () {
    axios.post(this.endpoint, { csrfToken: this.props.csrfToken }).then(res => {
      this.setState({ apiKey: res.data.key })
    }).catch(() => {
      this.setState({ apiKey: 'Could not generate key, please try again later.' })
    })
  }

  render (props, state) {
    const { apiKey } = state
    return (
      <div class='integrations-zapier'>
        <Panel title={<IntegrationHeader isInstalled={false} name='Zapier' description='Connect inSided with thousands of other apps like Slack and Jira to build workflows, automate repetitive tasks and save time.'><ZapierLogo /></IntegrationHeader>}>
          <InputGroup type='text' qaClasses='qa-zapier-api-key-input' readOnly='readonly' value={apiKey} placeholder='Click the button to generate API key' />
          { apiKey === null
            ? <ButtonControl variant='primary' title='Generate API Key' class={'qa-generate-api-key'} onClick={this.onGenerateApiKey} /> : null }
        </Panel>
      </div>
    )
  }
}

export default ZapierIntegration
